import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TaxonomySettings } from '../settings/Taxonomy';
import { TopicCustomFieldsSettings } from '../settings/TopicCustomFields';
import { PublishingSettings } from '../settings/Publishing';
import { InkSection } from '../cms/shared';

/**
 * tinycms → Content → Content settings (the button on every Content tab,
 * Prototype v14), titled Article settings here as Form and Media settings
 * title theirs. Taxonomy, custom fields, and publishing rules. The left
 * column owns each title. The editors render only their card, and each asks
 * before the page is left with its changes unsaved (useLeaveGuard).
 */
export function ContentSettings() {
  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id) return;
    document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, []);

  return (
    <main className="ink-body">
      <Link to="/content" className="ink-muted" style={{ textDecoration: 'none' }}>
        ← Articles
      </Link>
      <h1 className="ink-h1" style={{ marginTop: 10 }}>
        Article settings
      </h1>
      <p className="ink-lede" style={{ paddingBottom: 12 }}>
        How content is structured, and the checks it passes before it goes live. Agents read these
        too.
      </p>
      <InkSection
        id="taxonomy"
        title="Taxonomy"
        description="The terms Prism AI may use when it classifies an article’s facts. It picks only from these, and skips a dimension with no terms. An article’s own topic (shown on Articles, often from its feed) is separate and isn’t changed here."
      >
        <TaxonomySettings embedded />
      </InkSection>
      <InkSection
        id="fields"
        title="Custom fields"
        description="Extra structured data for each article. These are visible only to this account."
      >
        <TopicCustomFieldsSettings embedded />
      </InkSection>
      <InkSection
        id="publishing"
        title="Publishing rules"
        description="Checks every article passes before it goes live, and the house style the copy edit follows."
      >
        <PublishingSettings embedded />
      </InkSection>
    </main>
  );
}
